import React, { useContext } from "react";
import PropTypes from "prop-types";
import styles from "./pomocode.module.css";
import {
  FaTag,
  FaCalendarAlt,
  FaUser,
  FaPercent,
  FaTimes,
} from "react-icons/fa";
import { toast } from "react-toastify";
import LoaderContext from "../../../Components/loader";
import {
  approvalStatusApi,
} from "../../../App/api/multilevelApproval.api";
import ApprovalFlowManager from "../ApprovalFlowManager";
import ApprovalStatus from "../ApprovalStatus";

const PromoSidebar = ({
  data,
  onClose,
  isOpen,
  getAllData,
  actionData,
  title,
  endPoint,
  approvalStatus,
}) => {
  const { handleLoading } = useContext(LoaderContext);
  const {
    approvalLevel,
    ApprovalFlow,
    allApprovals,
        matchedData,
    waitingForApproval,
    validateAndApprove,
  } = ApprovalFlowManager({
    component: title === "Promocode Approval" ? "PromoCode" : "Sale",
    currentItems:data,
    approvalStatus,
  });
   
  const onApprove = async () => {
    const payload = {
      component_id: data?._id,
      component: title === "Promocode Approval" ? "PromoCode" : "Sale",
      approvalFlow: allApprovals?.data?.[0]?._id,
      progress: {
        level: approvalLevel?.level,
        user: approvalLevel?.user,
        status: actionData,
        remarks: "",
      },
    };

    if (!validateAndApprove(payload)) {
      handleLoading(false);
      return;
    }
    handleLoading(true);
    try {
      ApprovalFlow?.length > 0
        ? await approvalStatusApi.updateApprovalStatus(
            payload,
            ApprovalFlow?.[0]?._id
          )
        : await approvalStatusApi.createApprovalStatus(payload);
      getAllData();
      handleLoading(false);
      onClose();
      toast.success(
        `${
          title === "Promocode Approval" ? "PromoCode" : "Sale"
        } ${actionData} by ${approvalLevel?.level}!`
      );
      // toast.success("Item has been approved successfully");
    } catch (error) {
      handleLoading(false);
      toast.error(error.message);
    }
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={onClose}
        ></div>
      )}

      <aside
        className={`fixed top-0 right-0 h-full w-[28rem] bg-white shadow-lg p-6 z-50 transform transition-transform duration-300 ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex justify-between items-center">
          <h3 className="font-bold text-xl ">{title}</h3>
          <button
            onClick={onClose}
            className=" text-gray-600 hover:text-gray-800"
          >
            <FaTimes className="text-2xl" />
          </button>
        </div>
        <hr className="my-5" />

        {data ? (
          <>
            <div className="relative mt-5 h-48 rounded-lg overflow-hidden shadow-md">
              <img
                src={data.image}
                alt="Promo"
                className="w-full h-full object-cover"
              />
              <span
                className={`absolute top-2 left-2 ${
                  data?.status === "Approved" ? "bg-green-500" : "bg-red-500"
                } text-white px-3 py-1 rounded text-sm`}
              >
                {data.status || "N/A"}
              </span>
            </div>
            <div
              className={`${styles.customScrollbar} scroll-my-3 p-2 overflow-y-auto h-[65%]`}
            >
              <div className="mt-6 space-y-4">
                <div className="flex items-center justify-between">
                  <h2 className="text-2xl font-bold text-gray-800 capitalize">
                    {data.promo_code?.toUpperCase() || data.sale_name || ""}
                  </h2>
                  <div className="flex items-center space-x-2">
                    <FaTag className="text-gray-600" />
                    <span className="text-gray-700 text-sm">
                      {data.discount_type || "N/A"}
                    </span>
                  </div>
                </div>
                <p className="text-gray-600">
                  {data.description ||
                    "No description available. Apply this promo code at checkout to enjoy the benefits!"}
                </p>
              </div>

              <div className="mt-4 p-4 bg-gray-100 rounded-lg shadow-sm">
                <div className="flex items-center space-x-3">
                  <FaPercent className="text-blue-500" />
                  <span className="text-sm font-medium text-gray-700">
                    Discount
                  </span>
                </div>
                <h3 className="text-lg font-semibold text-gray-800">
                  {data.discount?.$numberDecimal || "0"}%
                </h3>
              </div>

              <div className="mt-4 p-4 bg-gray-100 rounded-lg shadow-sm">
                <div className="flex items-center space-x-3">
                  <FaCalendarAlt className="text-green-500" />
                  <span className="text-sm font-medium text-gray-700">
                    Active Period
                  </span>
                </div>
                <p className="text-sm text-gray-600 mt-2">
                  <span className="font-medium">Start Date:</span>{" "}
                  {data.start_date
                    ? new Date(data.start_date).toLocaleDateString()
                    : "N/A"}
                </p>
                <p className="text-sm text-gray-600">
                  <span className="font-medium">End Date:</span>{" "}
                  {data.end_date
                    ? new Date(data.end_date).toLocaleDateString()
                    : "N/A"}
                </p>
                <p className="text-sm text-gray-600">
                  <span className="font-medium">Recurrence:</span>{" "}
                  {data.repeat || "N/A"}
                </p>
              </div>

              <div className="mt-4 p-4 bg-gray-100 rounded-lg shadow-sm">
                <div className="flex items-center space-x-3">
                  <FaUser className="text-purple-500" />
                  <span className="text-sm font-medium text-gray-700">
                    Vendor Details
                  </span>
                </div>
                <div className="flex items-center space-x-4 mt-4">
                  <img
                    src={data.created_by?.profile_image}
                    alt="Creator"
                    className="w-12 h-12 rounded-full shadow-md"
                  />
                  <div>
                    <p className="text-sm font-medium text-gray-800">
                      {data.created_by?.first_name || "N/A"}
                    </p>
                    <p className="text-sm text-gray-500">
                      {data.created_by?.email || "N/A"}
                    </p>
                    <p className="text-sm text-gray-500">
                      {data.created_by?.phone_number || "N/A"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="my-5">
                <h3 className="text-lg font-semibold text-gray-700">
                  Additional Details
                </h3>
                <ul className="mt-2 space-y-2">
                  <li className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">
                      Min Cart Items
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {data.min_item_on_cart || 0}
                    </span>
                  </li>
                  <li className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">
                      Min Order Amount
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {data.min_order_amount?.$numberDecimal || "0"}
                    </span>
                  </li>
                  <li className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">
                      Max Discount Amount
                    </span>
                    <span className="text-sm font-medium text-gray-800">
                      {data.max_discount_amount?.$numberDecimal || "0"}
                    </span>
                  </li>
                </ul>
              </div>
              {/*Approval section */}
              <ApprovalStatus
                  matchedData={matchedData}
                  waitingForApproval={waitingForApproval}
                />
            </div>

            <div className="mt-6">
              {ApprovalFlow?.[0]?.progress?.status === "Approved" ? (
                <button
                  disabled
                  className="w-full py-3 bg-green-500 text-white rounded-lg font-semibold shadow-md cursor-not-allowed"
                >
                  Approved
                </button>
              ) : (
                <button
                  onClick={onApprove}
                  className={`w-full py-3 ${
                    ApprovalFlow?.[0]?.progress?.status === "Pending"
                      ? "bg-yellow-500 hover:bg-yellow-600"
                      : "bg-red-500 hover:bg-red-600"
                  }  text-white rounded-lg font-semibold shadow-md `}
                >
                  Approve
                </button>
              )}
            </div>
          </>
        ) : (
          <div className="flex items-center justify-center h-full text-gray-500">
            No Data Available
          </div>
        )}
      </aside>
    </>
  );
};

PromoSidebar.propTypes = {
  data: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onApprove: PropTypes.func.isRequired,
};

export default PromoSidebar;
